module.exports = __webpack_public_path__ + "static/media/laxmirajmv3.1dbf2888.png";